export const ROOT_GLOBAL = {
  HOME_PAGE: "/",
  LOGIN: "/?page=login",
  SIGN_UP: "/?page=signup",
  USER_CLASSIFICATION: "/classification",
  USER_DUTY_TAX_CALCULATION: "/duty-tax-calculation",
  USER_TRADE_ADVISORY: "/trade-advisory",
  YOUR_PLAN: "/your-plan",
  PROFILE_MANAGE: "/profile-management",
  UK_POPUP: "/uk-government-grant-funding"
}

export const REQUIRE_LOGIN_PATHS = [
  // ROOT_GLOBAL.USER_CLASSIFICATION,
  ROOT_GLOBAL.USER_DUTY_TAX_CALCULATION,
  ROOT_GLOBAL.USER_TRADE_ADVISORY,
  ROOT_GLOBAL.YOUR_PLAN,
  ROOT_GLOBAL.PROFILE_MANAGE
]

export const REQUIRE_UN_LOGIN_PATHS = [
  ROOT_GLOBAL.HOME_PAGE
]